import Vue from "vue";
import VueCookies from "vue-cookies";

Vue.use(VueCookies);
Vue.$cookies.config("7d", "/", process.env.VUE_APP_COOKIE_DOMAIN);

export default Vue.$cookies;
